import React, { Suspense, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { useRoutes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Themeroutes from './routes/Router'

import ThemeSelector from './layouts/theme/ThemeSelector'
import Loader from './layouts/loader/Loader'
import './i18n'

import 'react-table-v6/react-table.css'
import 'react-datetime/css/react-datetime.css'
import 'react-toastify/dist/ReactToastify.css'

// function useToken() {
//   const getToken = () => {
//     const tokenString = localStorage.getItem('token');
//     const userToken = JSON.parse(tokenString);
//     return userToken;
//   };

//   const [token, setToken] = useState(getToken());

//   const saveToken = (userToken) => {
//     localStorage.setItem('token', JSON.stringify(userToken));
//     setToken(userToken);
//   };

//   return {
//     setToken: saveToken,
//     token,
//   };
// }

const App = () => {
  // const { token, setToken } = useToken();

  const routing = useRoutes(Themeroutes)
  const direction = useSelector((state) => state.customizer.isRTL)
  const isMode = useSelector((state) => state.customizer.isDark)

  const title = process.env.REACT_APP_WEBSITE_TITLE || ''

  useEffect(() => {
    document.title = title
  }, [])

  return (
    <Suspense fallback={<Loader />}>
      <div
        className={`${direction ? 'rtl' : 'ltr'} ${isMode ? 'dark' : ''}`}
        dir={direction ? 'rtl' : 'ltr'}
      >
        <ToastContainer
          position="top-left"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ThemeSelector />
        {routing}
      </div>
    </Suspense>
  )
}

export default App
